import { render, staticRenderFns } from "./TheMoreDetailsBtn.vue?vue&type=template&id=7be838bc&scoped=true"
import script from "./TheMoreDetailsBtn.vue?vue&type=script&lang=ts"
export * from "./TheMoreDetailsBtn.vue?vue&type=script&lang=ts"
import style0 from "./TheMoreDetailsBtn.vue?vue&type=style&index=0&id=7be838bc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7be838bc",
  null
  
)

export default component.exports